import React from 'react';

export default function LoadingSpinner({ text = '加载中...' }: { text?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="w-10 h-10 rounded-full border-4 border-slate-200/80 border-t-slate-950 animate-spin" />
      <p className="mt-4 text-slate-500">{text}</p>
    </div>
  );
}
